import React from 'react';
import { Typography, Grid, Card, CardContent, CardActionArea, Box, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Reuse some existing images or placeholders
import pensionImg from '../../Assets/image1.jpg';
import hotelImg from '../../Assets/hotel.png';
import guesthouseImg from '../../Assets/kulcsoshaz.png';
import barnImg from '../../Assets/csur.png';
import campingImg from '../../Assets/camping.png';

function AccommodationMarket() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const accommodationCategories = [
    {
      id: 'pension',
      title: t('SubMenu.Pension'),
      path: '/all-accommodation-listings?type=Pension',
      image: pensionImg,
      description: t('Accommodation.PensionDesc', 'Traditional pensions with local hospitality.')
    },
    {
      id: 'hotel',
      title: t('SubMenu.Hotel'),
      path: '/all-accommodation-listings?type=Hotel',
      image: hotelImg,
      description: t('Accommodation.HotelDesc', 'Modern hotels with full services.')
    },
    {
      id: 'guesthouse',
      title: t('SubMenu.Guesthouse'),
      path: '/all-accommodation-listings?type=Guesthouse',
      image: guesthouseImg,
      description: t('Accommodation.GuesthouseDesc', 'Privát kulcsosházak a teljes kikapcsolódáshoz.')
    },
    {
      id: 'barn',
      title: t('SubMenu.Barn'),
      path: '/all-accommodation-listings?type=Barn',
      image: barnImg,
      description: t('Accommodation.BarnDesc', 'Unique experience in converted traditional barns.')
    },
    {
      id: 'camping',
      title: t('SubMenu.Camping'),
      path: '/all-accommodation-listings?type=Camping',
      image: campingImg,
      description: t('Accommodation.CampingDesc', 'Beautiful camping sites close to nature.')
    }
  ];

  const CategoryCard = ({ cat }) => (
    <Grid item xs={12} sm={6} md={4} key={cat.id}>
      <Card sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        height: '100%',
        transition: 'transform 0.2s',
        '&:hover': { transform: 'scale(1.02)', boxShadow: 6 }
      }}>
        <CardActionArea 
          onClick={() => navigate(`/${i18n.language}${cat.path}`)}
          sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
        >
          <Box sx={{ height: '200px', overflow: 'hidden' }}>
            <img 
              src={cat.image} 
              alt={cat.title} 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
          <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="h5" component="h2" sx={{ color: '#105b79', fontWeight: 'bold' }}>
              {cat.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {cat.description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: '50px' }}>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Typography variant="h3" align="center" sx={{ color: '#105b79', fontWeight: 'bold' }}>
          {t('Header.Szallas')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button 
            variant="contained" 
            onClick={() => navigate(`/${i18n.language}/szallasterkep`)}
            sx={{ bgcolor: '#105b79', '&:hover': { bgcolor: '#0d4a63' } }}
          >
            {t('Map.ShowOnMap', 'Megtekintés térképen')}
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => navigate(`/${i18n.language}/addaccommodation`)}
            sx={{ color: '#2492be', borderColor: '#2492be', '&:hover': { borderColor: '#105b79', color: '#105b79' } }}
          >
            {t('Accommodation.RegisterAsProvider', 'Jelentkezés szállásadóként')}
          </Button>
        </Box>
      </Box>

      <Grid container spacing={4}>
        {accommodationCategories.map((cat) => (
          <CategoryCard key={cat.id} cat={cat} />
        ))}
      </Grid>
    </Container>
  );
}

export default AccommodationMarket;
